import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedComics() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">高分好评漫画，每一部都值得阅读</p>
          </div>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featuredComics.slice(0, 5).map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={comic.coverUrl}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap">
                    {comic.rating}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <p className="text-background-50 text-xs line-clamp-2">{comic.description}</p>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}